module.exports = __webpack_public_path__ + "img/horizontal_6_6_pp3_9006.65800b9e.png";